import { Modal, Tabs } from "antd";
import { AppstoreAddOutlined } from "@ant-design/icons";
import ModuleTabContent from "./ModuleTabContent";
import { useTheme } from "../../../services/useTheme";

const LogoIcon = ({ src, alt }) => (
  <img
    src={src}
    alt={alt}
    className="menu-logo"
    style={{
      width: 20,
      verticalAlign: "middle",
      marginRight: 8,
      borderRadius: 4,
    }}
  />
);

export default function ProjectModulesModal({
  project,
  onClose,
  onSuccess,
  isManager,
  userData,
}) {
  if (!project) return null;

  const isDarkTheme = useTheme();

  const MODULE_CONFIG = {
    skeyenote: {
      label: "Skeyenote",
      icon: (
        <LogoIcon
          src={`/img/majesteye-icon-skeye-note-square-white-background-no-label${isDarkTheme ? "-white" : ""}.png`}
          alt="Skeyenote"
        />
      ),
      projectKey: "skeyenote",
      idField: "noteId",
      displayField: "notePath",
      availableIdField: "id",
      availableDisplayField: "path",
      payloadKey: "notes",
      transformForLink: (r) => ({ noteId: r.id, notePath: r.path }),
    },
    skeyechart: {
      label: "Skeyechart",
      icon: (
        <LogoIcon
          src={`/img/majesteye-icon-skeye-charts-square-white-background-no-label${isDarkTheme ? "-white" : ""}.png`}
          alt="Skeyecharts"
        />
      ),
      projectKey: "skeyechart",
      idField: "id",
      displayField: "dashboard_title",
      payloadKey: "dashboards",
    },
    skeyeingest: {
      label: "Skeyeingest",
      icon: (
        <LogoIcon
          src={`/img/majesteye-icon-skeye-ingest-square-white-background-no-label${isDarkTheme ? "-white" : ""}.png`}
          alt="Skeyeingest"
        />
      ),
      projectKey: "skeyeingest",
      idField: "pipelineId",
      displayField: "title",
      payloadKey: "pipelines",
    },
    skeyecube: {
      label: "Skeyecube",
      icon: (
        <LogoIcon
          src={`/img/majesteye-icon-skeye-cube-square-white-background-no-label${isDarkTheme ? "-white" : ""}.png`}
          alt="Skeyecube"
        />
      ),
      projectKey: "skeyecube",
      idField: "uuid",
      displayField: "name",
      payloadKey: "cubeProjects",
    },
    skeyepredict: {
      label: "Skeyepredict",
      icon: (
        <LogoIcon
          src={`/img/majesteye-icon-skeye-predict-square-white-background-no-label${isDarkTheme ? "-white" : ""}.png`}
          alt="Skeyepredict"
        />
      ),
      projectKey: "skeyepredict",
      idField: "id",
      displayField: "id",
      payloadKey: "predictProjects",
    },
    jeyeda: {
      label: "Jeyeda",
      icon: <LogoIcon src="/img/Jeyeda_logo_no_text.png" alt="Jeyeda" />,
      projectKey: "jeyeda",
      idField: "id",
      displayField: "label",
      payloadKey: "jeyedaProjects",
    },
  };

  const items = Object.entries(MODULE_CONFIG).map(([key, config]) => ({
    key,
    label: (
      <span>
        {config.icon}
        {config.label}
      </span>
    ),
    children: (
      <ModuleTabContent
        project={project}
        config={config}
        moduleName={key}
        onRefreshData={onSuccess}
        isManager={isManager}
        userData={userData}
      />
    ),
  }));

  return (
    <Modal
      title={
        <span>
          <AppstoreAddOutlined style={{ color: "#D97A07", marginRight: 8 }} />
          Modules — {project.title}
        </span>
      }
      open={true}
      onCancel={onClose}
      footer={null}
      width={1200}
      styles={{ body: { height: "75vh" } }}
    >
      <Tabs defaultActiveKey="skeyenote" items={items} />
    </Modal>
  );
}
